import {CheckCircle, X} from "react-feather";
import React from "react";

const SuccessToaster = ({label, position = "bottom_left", timeout = 4000}) => {

    const [isShown, setIsShown] = React.useState(true);

    React.useEffect(() => {
        setTimeout(() => {
            setIsShown(false);
        }, timeout)

    }, [timeout])

    const close = () => {
        setIsShown(false);
    }

    if (!isShown)
        return;

    let toasterClass = '';

    // eslint-disable-next-line default-case
    switch (position) {
        case 'bottom_left' :
            toasterClass = 'sl-bottom-5 sl-left-5';
            break;
        case 'bottom_right' :
            toasterClass = 'sl-bottom-5 sl-right-5';
            break;
        case 'top_right' :
            toasterClass = 'sl-top-5 sl-right-5';
            break;
        case 'top_left' :
            toasterClass = 'sl-top-5 sl-left-5';
            break;
    }

    return <div
        className={`sl-fixed ${toasterClass} sl-bg-success-25 sl-flex-row sl-flex sl-gap-3 sl-p-4 sl-border-radius-8 sl-border-solid sl-border-1 sl-border-success-300`}>
        <CheckCircle size={20} className="sl-text-success-700"/>
        <span className="sl-text-success-700">{label}</span>
        <X size={20} className="sl-text-success-700 sl-cursor-pointer" onClick={close}/>
    </div>
}

export default SuccessToaster;